import role from './role';

export const isTokenExpired = exp => exp < Math.floor(Date.now() / 1000);

export const isLoggedIn = auth =>
  auth.token !== null && !isTokenExpired(auth.expiration);

export const isToolingSearchAuthorized = auth =>
  auth.role === `${role.superAdmin}` ||
  auth.role === `${role.govtUser}`;





// WEBPACK FOOTER //
// ./src/components/Auth/utils.js